"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnlockableViewImpressionTrack = exports.UnlockableViewImpressionTrack_SnappableInviteAction = exports.UnlockableViewImpressionTrack_SnapViewType = void 0;
/* eslint-disable */
const device_info_1 = require("./device/device_info");
const minimal_1 = __importDefault(require("protobufjs/minimal"));
const wrappers_1 = require("../../../google/protobuf/wrappers");
var UnlockableViewImpressionTrack_SnapViewType;
(function (UnlockableViewImpressionTrack_SnapViewType) {
    UnlockableViewImpressionTrack_SnapViewType[UnlockableViewImpressionTrack_SnapViewType["UNKNOWN_SNAP_VIEW_TYPE"] = 0] = "UNKNOWN_SNAP_VIEW_TYPE";
    UnlockableViewImpressionTrack_SnapViewType[UnlockableViewImpressionTrack_SnapViewType["DIRECT_SNAP"] = 1] = "DIRECT_SNAP";
    UnlockableViewImpressionTrack_SnapViewType[UnlockableViewImpressionTrack_SnapViewType["STORY"] = 2] = "STORY";
    UnlockableViewImpressionTrack_SnapViewType[UnlockableViewImpressionTrack_SnapViewType["MEMORY_PREVIEW"] = 3] = "MEMORY_PREVIEW";
    UnlockableViewImpressionTrack_SnapViewType[UnlockableViewImpressionTrack_SnapViewType["MEMORY_EDIT"] = 4] = "MEMORY_EDIT";
    UnlockableViewImpressionTrack_SnapViewType[UnlockableViewImpressionTrack_SnapViewType["MEMORY_TILE"] = 5] = "MEMORY_TILE";
    UnlockableViewImpressionTrack_SnapViewType[UnlockableViewImpressionTrack_SnapViewType["DIRECT_SNAP_WITH_MODULAR_CAMERA"] = 6] = "DIRECT_SNAP_WITH_MODULAR_CAMERA";
    UnlockableViewImpressionTrack_SnapViewType[UnlockableViewImpressionTrack_SnapViewType["STORY_WITH_MODULAR_CAMERA"] = 7] = "STORY_WITH_MODULAR_CAMERA";
    UnlockableViewImpressionTrack_SnapViewType[UnlockableViewImpressionTrack_SnapViewType["LENS_CAROUSEL"] = 8] = "LENS_CAROUSEL";
    UnlockableViewImpressionTrack_SnapViewType[UnlockableViewImpressionTrack_SnapViewType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(UnlockableViewImpressionTrack_SnapViewType = exports.UnlockableViewImpressionTrack_SnapViewType || (exports.UnlockableViewImpressionTrack_SnapViewType = {}));
var UnlockableViewImpressionTrack_SnappableInviteAction;
(function (UnlockableViewImpressionTrack_SnappableInviteAction) {
    UnlockableViewImpressionTrack_SnappableInviteAction[UnlockableViewImpressionTrack_SnappableInviteAction["UNKNOWN_SNAPPABLE_INVITE_ACTION"] = 0] = "UNKNOWN_SNAPPABLE_INVITE_ACTION";
    UnlockableViewImpressionTrack_SnappableInviteAction[UnlockableViewImpressionTrack_SnappableInviteAction["JOIN"] = 1] = "JOIN";
    UnlockableViewImpressionTrack_SnappableInviteAction[UnlockableViewImpressionTrack_SnappableInviteAction["SKIP"] = 2] = "SKIP";
    UnlockableViewImpressionTrack_SnappableInviteAction[UnlockableViewImpressionTrack_SnappableInviteAction["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(UnlockableViewImpressionTrack_SnappableInviteAction = exports.UnlockableViewImpressionTrack_SnappableInviteAction || (exports.UnlockableViewImpressionTrack_SnappableInviteAction = {}));
function createBaseUnlockableViewImpressionTrack() {
    return {
        timeViewedSeconds: undefined,
        mediaDurationSeconds: undefined,
        encGeoData: new Uint8Array(),
        isAudioOn: undefined,
        snapViewType: 0,
        deviceInfo: undefined,
        snappableInviteAction: 0,
    };
}
exports.UnlockableViewImpressionTrack = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.timeViewedSeconds !== undefined) {
            wrappers_1.FloatValue.encode({ value: message.timeViewedSeconds }, writer.uint32(10).fork()).ldelim();
        }
        if (message.mediaDurationSeconds !== undefined) {
            wrappers_1.FloatValue.encode({ value: message.mediaDurationSeconds }, writer.uint32(18).fork()).ldelim();
        }
        if (message.encGeoData.length !== 0) {
            writer.uint32(26).bytes(message.encGeoData);
        }
        if (message.isAudioOn !== undefined) {
            wrappers_1.BoolValue.encode({ value: message.isAudioOn }, writer.uint32(34).fork()).ldelim();
        }
        if (message.snapViewType !== 0) {
            writer.uint32(40).int32(message.snapViewType);
        }
        if (message.deviceInfo !== undefined) {
            device_info_1.DeviceInfo.encode(message.deviceInfo, writer.uint32(50).fork()).ldelim();
        }
        if (message.snappableInviteAction !== 0) {
            writer.uint32(56).int32(message.snappableInviteAction);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseUnlockableViewImpressionTrack();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.timeViewedSeconds = wrappers_1.FloatValue.decode(reader, reader.uint32()).value;
                    break;
                case 2:
                    message.mediaDurationSeconds = wrappers_1.FloatValue.decode(reader, reader.uint32()).value;
                    break;
                case 3:
                    message.encGeoData = reader.bytes();
                    break;
                case 4:
                    message.isAudioOn = wrappers_1.BoolValue.decode(reader, reader.uint32()).value;
                    break;
                case 5:
                    message.snapViewType = reader.int32();
                    break;
                case 6:
                    message.deviceInfo = device_info_1.DeviceInfo.decode(reader, reader.uint32());
                    break;
                case 7:
                    message.snappableInviteAction = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseUnlockableViewImpressionTrack();
        message.timeViewedSeconds = object.timeViewedSeconds ?? undefined;
        message.mediaDurationSeconds = object.mediaDurationSeconds ?? undefined;
        message.encGeoData = object.encGeoData ?? new Uint8Array();
        message.isAudioOn = object.isAudioOn ?? undefined;
        message.snapViewType = object.snapViewType ?? 0;
        message.deviceInfo =
            object.deviceInfo !== undefined && object.deviceInfo !== null
                ? device_info_1.DeviceInfo.fromPartial(object.deviceInfo)
                : undefined;
        message.snappableInviteAction = object.snappableInviteAction ?? 0;
        return message;
    },
};
//# sourceMappingURL=unlockable_view_impression_track.js.map